import { useUser } from "@context/User/UserContext";
import React, { useEffect, useRef } from "react";
import TagManager from "react-gtm-module";

const GTM_ID = "GTM-M63PMSS";

interface GTMProviderProps {
  children: React.ReactNode;
}

/**
 * Get the current domain based on the environment
 */
const getCurrentDomain = (): string => {
  return window.location.host;
};

/**
 * Provider component that initializes Google Tag Manager
 * and updates user data when user changes
 */
const GTMProvider: React.FC<GTMProviderProps> = ({ children }) => {
  const { user, isLoading } = useUser();
  const isInitialized = useRef(false);

  useEffect(() => {
    // Initialize GTM only once when user data is available (or loading is complete)
    if (!isInitialized.current && !isLoading) {
      const tagManagerArgs = {
        gtmId: GTM_ID,
        dataLayer: {
          site: "ara",
          domain: getCurrentDomain(),
          user: {
            id: user?.userId?.toString() || ""
          }
        }
      };

      TagManager.initialize(tagManagerArgs);
      isInitialized.current = true;
    }
  }, [isLoading, user?.userId]);

  useEffect(() => {
    // Update dataLayer when user changes (only if already initialized)
    if (isInitialized.current && user?.userId) {
      TagManager.dataLayer({
        dataLayer: {
          user: {
            id: user.userId.toString()
          }
        }
      });
    }
  }, [user?.userId]);

  return <>{children}</>;
};

export default GTMProvider;
